import { render } from "./reallocations-subpage.vue?vue&type=template&id=7db06f9b"
import script from "./reallocations-subpage.vue?vue&type=script&lang=js"
export * from "./reallocations-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__